import { createAction } from 'redux-actions'
import { isArray, last, find} from 'lodash'

import * as Services from 'Services'
import * as cs from 'state/customize'
import { getOption } from 'state/customize/selectors'
import * as Instance from 'models/Instance'
import * as Putter from 'models/Putter'
import { createTrackedAction } from '../../util/analytics'

const CLEAR = 'sc/customize/CLEAR';
const LOAD_PUTTER = 'sc/customize/LOAD_PUTTER';
const START_LOAD = 'sc/customize/START_LOAD';
const SELECT = 'sc/customize/SELECT';
const SET_FIELD = 'sc/customize/SET_FIELD';
const PAINT = 'sc/customize/PAINT';
const INITIALS = 'sc/customize/INITIALS';
const STAMP = 'sc/customize/STAMP';
const CANCEL_REPLACE_PAINT = 'sc/customize/CANCEL_REPLACE_PAINT';
const REPLACE_PAINT = 'sc/customize/REPLACE_PAINT';
const SELECT_VIEW = 'sc/customize/SELECT_VIEW';
const TOGGLE_VIEW_ZOOM = 'sc/customize/TOGGLE_VIEW_ZOOM';
const SELECT_ACCESSORY_TYPE = 'sc/customize/SELECT_ACCESSORY_TYPE';
const PERFORM_ADD_TO_CART_CALL = 'sc/customize/PERFORM_ADD_TO_CART_CALL';
const PERFORM_ADD_TO_SAVED_CALL = 'sc/customize/PERFORM_ADD_TO_SAVED_CALL';

const SET_INSTANCE_INTENT = 'sc/customize/SET_INSTANCE_INTENT';
const LOAD_INSTANCE = 'sc/customize/LOAD_INSTANCE';
const LOAD_ORDER_INSTANCE = 'sc/customize/LOAD_ORDER_INSTANCE';
const LOAD_DEFAULT_INSTANCE = 'sc/customize/LOAD_DEFAULT_INSTANCE';

const RESET_PAINTFILLS = 'sc/customize/RESET_PAINTFILLS';
const CLEAR_PAINTFILLS = 'sc/customize/CLEAR_PAINTFILLS';
const CHECK_PAINT_SWAP_VALID = 'sc/customize/CHECK_PAINT_SWAP_VALID';
const APPLY_FINISH = 'sc/customize/APPLY_FINISH';

/* 18759: Invalid options rollback
const TOGGLE_SHOW_INVALID_OPTIONS_REMOVED_WARNING = 'sc/customize/TOGGLE_SHOW_INVALID_OPTIONS_REMOVED_WARNING';
*/

const initialState = cs.initialState

export default function reducer(state = initialState, action = {}) {
  // Only part of the state is stored in localStorage.
  // This merges the initial state with the stored state on load 
  if (!state.hydrated){
    state = {
      ...initialState,
      ...state,
      instanceIntent:'',
      selectedView:'FS',
      isViewZoomIn: false,
      selectedAccessoryType: 'grip',
      hydrated:true
    } 
  }

  switch (action.type) {
    case CLEAR:
      return initialState;
    case SET_INSTANCE_INTENT:
      return Object.assign({}, state, { instanceIntent: action.payload }); 

    case START_LOAD:
      return {
        ...state,
        loading:true,
      }

    case LOAD_PUTTER:
      if(action.error){ return state;}
      // If loading from localStorage, we still want to pull the updated putter from API 
      // but use the instance from localStorage, as long as the instance is an instance of the putter
      const putter = Putter.fromAPI(action.payload);
      var instance = (state.instance && state.instance.model === putter.id) ? 
        state.instance: 
        Instance.fromPutter(putter);
      /* 18759: Invalid options rollback
      const isInstanceOptionsValid = Instance.isInstanceOptionsValid(putter, instance);
      return Object.assign({}, state, { putter, instance, loading: false, showInvalidOptionsRemovedWarning: !isInstanceOptionsValid, });
      */
      instance = Instance.removeInvalidOptions(putter, instance);
      return Object.assign({}, state, { putter, instance, loading: false });
    case LOAD_DEFAULT_INSTANCE:  
      if(action.error){ return state;}
      const defaultInstance = Instance.fromAPIInstance(action.payload);
      let currentInstance = state.instance;
      if(!currentInstance.customInstanceId)
      { 
        currentInstance = Instance.fromDefaultInstance(state.instance, defaultInstance); 
      }
      return Object.assign({}, state, { defaultInstance, instance: currentInstance });
    case LOAD_INSTANCE:
    case LOAD_ORDER_INSTANCE:
      if(action.error){ return Object.assign({}, state, { instance: null, loading: false  }); }
      const savedInstance = Instance.fromAPIInstance(action.payload);
      return Object.assign({}, state, { instance: savedInstance, loading: false });
    case SELECT_VIEW:
      return Object.assign({}, state, { selectedView: action.payload })
    case TOGGLE_VIEW_ZOOM:
      return Object.assign({}, state, { isViewZoomIn: !state.isViewZoomIn })
    case SELECT:
      return cs.select(state, action.payload.field, action.payload.id);
    case SET_FIELD:
      return cs.setValue(state, action.payload.field, action.payload.value);
    case PAINT:
      try{ 
        if (isArray(action.payload.location)){
          return action.payload.location.reduce((state, loc) => (cs.selectPaint(state, loc, action.payload.color)), state);
        }
        return cs.selectPaint(state, action.payload.location, action.payload.color);
      }catch (e){
        if (e.name !== 'MaxColorsError') { throw (e); }
        state = Object.assign({}, state, { replacementPaintFill: action.payload }) 
        return state; 
      }
    case REPLACE_PAINT:
      return Object.assign({},
        (isArray(action.payload.location)) ? 
          cs.replacePaint(state, action.payload.oldColor, action.payload.newColor, action.payload.location) : 
          cs.replacePaint(state, action.payload.oldColor, action.payload.newColor, (action.payload.location ? [action.payload.location] : null ) ),
        { replacementPaintFill: null }
      );
    case CANCEL_REPLACE_PAINT:
      return Object.assign({}, state, { replacementPaintFill: null }) 
    case RESET_PAINTFILLS:
      return cs.clearInvalidPaints(cs.setDefaultPaintFills(cs.clearAllPaintFills(state)));
    case CLEAR_PAINTFILLS:
      return cs.clearAllPaintFills(state);
    case INITIALS:
      return cs.selectInitials(state, action.payload.location, action.payload.field, action.payload.value);
    case STAMP:
      return cs.selectStamp(state, action.payload.locationId, action.payload.field, action.payload.value);
    case SELECT_ACCESSORY_TYPE:
      return Object.assign({}, state, { selectedAccessoryType: action.payload })
    case PERFORM_ADD_TO_CART_CALL: 
      let cartResponse  = action.payload;
      console.log("ADD TO CART:", cartResponse);
      return state;
    case PERFORM_ADD_TO_SAVED_CALL: 
      let saveResponse  = action.payload;
      console.log("ADD TO SAVED:", saveResponse);
      return state;
    case CHECK_PAINT_SWAP_VALID:
      return Object.assign({}, state, { paintSwapValid: cs.checkPaintSwapValid(state, action.payload.oldColor, action.payload.newColor) })
    case APPLY_FINISH:
      return cs.applyFinish(state, action.payload.apply);
    /* 18759: Invalid options rollback
    case TOGGLE_SHOW_INVALID_OPTIONS_REMOVED_WARNING:
      return Object.assign({}, state, { showInvalidOptionsRemovedWarning: !state.showInvalidOptionsRemovedWarning })
    */
    default:
      return state;
  }
}

export const clearPutter = createAction(CLEAR);

export const startLoad = createAction(START_LOAD);
const performLoadPutter = createAction(LOAD_PUTTER, Services.getOptions); 
const performLoadDefaultInstance = createAction(LOAD_DEFAULT_INSTANCE, Services.getCustomInstance); 

export const loadPutter = (id, buy) => {
  return (dispatch, getState) =>{
    dispatch(startLoad());
    return dispatch(performLoadPutter(id)).then(() => {
      const defaultInstanceId = getState().customize.putter.defaultInstanceId;

      // Check if this putter is set to 'Buy A Putter'
      // Add it as an accessory if it is
      function setBuy(){ 
          if (buy) {
            let bp = getState().customize.putter.buyAPutter;
            if (Array.isArray(bp) && bp.length > 0) {
              dispatch(selectField('buyAPutter', bp[0].id));
            }
          }
      }

      if (!!defaultInstanceId && defaultInstanceId > 0){ 
        return dispatch(performLoadDefaultInstance(defaultInstanceId)).then(setBuy);
      }else{
        return setBuy(); 
      }
    }); 
  }
};

function getDefaultAuthenticationId(putter) {
  const option = find(putter.authentication, auth => auth.id > 0 && auth.id !== 99999);
  return option ? option.id : 0;
}

export const loadAuthenticatedPutter = (id) => {
  return (dispatch, getState) => {
    dispatch(clearPutter());
    return dispatch(loadPutter(id)).then(() => {
      const authenticationId = getDefaultAuthenticationId(getState().customize.putter);
      if (authenticationId) {
        dispatch(selectField('authentication', authenticationId));
      }
    });
  }
};

export const setInstanceIntent = createAction(SET_INSTANCE_INTENT);
const performLoadInstance = createAction(LOAD_INSTANCE, Services.getCustomInstance); 
const performLoadOrderInstance = createAction(LOAD_ORDER_INSTANCE, Services.getOrderInstance); 

// This used as utility to load instance data (e.g. packages, default paintfills)
// Does not affect 'intent'
export const loadInstance = (id) => {
  return (dispatch, getState) =>{
    dispatch(startLoad());
    dispatch(performLoadInstance(id));
  }
}

// These used by deep links registers user intent to control customizer behavior
// e.g. check user authorization, trigger button renaming, etc
export const loadInspirationInstance = (id) => {
  return (dispatch, getState) =>{
    dispatch(clearPutter());
    dispatch(setInstanceIntent(''));
    dispatch(loadInstance(id));
  }
} 
export const loadSavedInstance = (id) => {
  return (dispatch, getState) =>{
    dispatch(clearPutter());
    dispatch(setInstanceIntent('updateSaved'));
    dispatch(loadInstance(id));
  }
}
export const loadOrderInstance = (id) => {
  return (dispatch, getState) =>{
    dispatch(clearPutter());
    dispatch(setInstanceIntent('updateOrder'));
    dispatch(performLoadOrderInstance(id));
  }
}




export const selectField = createTrackedAction(SELECT, (field, id) => ({ field, id: (parseInt(id, 10) || 0) }), 
  {analyticsDataFcn:(action, state)=> {
    let opt = getOption(state, action.payload.field, action.payload.id);
    let field = action.payload.field; 
    if (field === "authentication"){
      field += " (" + last(window.location.href.split("/")) + " page)";
    } 

    var label = (opt && opt.label) || action.payload.id.toString();
    if (field.indexOf("Engraving") >= 0 && !opt){
      if (field === "weightEngraving" || field === "topWeightEngraving") { 
        label = "No"; 
      } else { 
        return null;
       }
    }

    return {
      category: "Custom Shop Field Selection",
      action: field,
      label: label
    }
}}
);
export const setFieldValue = createAction(SET_FIELD, (field, value) => ({ field, value }));

export const selectPaintFill = createTrackedAction(PAINT, (location, color)=> ({location, color}),
  {analyticsDataFcn:(action, state)=> { 
    let opt = getOption(state, 'paintFillLocations', [{
      locationId: action.payload.location[0] || action.payload.location, //some locations set multiple colors in the same action... just log the first
      colorId: action.payload.color
    }]);
    let loc = (opt && opt[0] && opt[0].location.label) || action.payload.location;
    let color = (opt && opt[0] && opt[0].color.label) || action.payload.color.toString();
    return {
      category: "Custom Shop Field Selection",
      action: "Paint " + loc,
      label: color
    }
  }}
);
export const changeInitials = createTrackedAction(INITIALS, (location, field, value)=> ({location, field, value}),
  {analyticsDataFcn:(action, state)=> {
    var val;
    if (action.payload.field === 'personalizationStyleId'){ 
      let opt = find(state.putter.personalizationStyle, { id: action.payload.value })
      val = opt && opt.label; 
    }else if (action.payload.field === 'characters'){
      val = action.payload.value.toUpperCase(); 
    }else{
      val = action.payload.value.toString();
    }

    return {
      category: "Custom Shop Field Selection",
      action: action.payload.location + " " + action.payload.field,
      label: val
    }},
    debounce: 500
  }
);
export const selectStamp = createTrackedAction(STAMP, (locationId, field, value)=> ({locationId, field, value}),
  {analyticsDataFcn:(action, state)=> { 
    var loc, val;
    if (action.payload.field === 'enabled'){ 
      let opt = find(state.putter.stampLocation, { id: action.payload.locationId }) ;
      loc = (opt && opt.label) + " Enabled";
      val = action.payload.value.toString();
    }else{ 
      let opt = getOption(state, 'stampSelections', [{
        locationId: action.payload.locationId, 
        stampId: action.payload.value
      }]);
      loc = (opt && opt[0] && opt[0].location.label) || action.payload.location;
      val = (opt && opt[0] && opt[0].stamp.label) || action.payload.value.toString();
    }
    return {
      category: "Custom Shop Field Selection",
      action: "Stamp " + loc,
      label: val
    }
  }}
);

export const replacePaint = createAction(REPLACE_PAINT, (oldColor, newColor, location) => ({ oldColor, newColor, location }));
export const cancelReplacementPaintFill = createAction(CANCEL_REPLACE_PAINT);
export const selectView = createAction(SELECT_VIEW);
export const toggleViewZoom = createTrackedAction(TOGGLE_VIEW_ZOOM);

export const selectAccessoryType = createAction(SELECT_ACCESSORY_TYPE);

export const resetPaintFills = createTrackedAction(RESET_PAINTFILLS);
export const clearPaintFills = createTrackedAction(CLEAR_PAINTFILLS);

const performAddToCartCall = createAction(PERFORM_ADD_TO_CART_CALL, (customizeState) =>
      Services.addToCart(Instance.formatForAPI(customizeState, "cart"))
)
export const addToCart =()=>{
  return (dispatch, getState) =>{
    return dispatch( performAddToCartCall(getState().customize) )
  }
};

const performAddToSavedCall = createAction(PERFORM_ADD_TO_SAVED_CALL, (customizeState) =>
      Services.addToSaved(Instance.formatForAPI(customizeState, "save"))
)
export const addToSaved =()=>{
  return (dispatch, getState) =>{
    return dispatch( performAddToSavedCall(getState().customize) )
  }
};

export const checkPaintSwapValid = createAction(CHECK_PAINT_SWAP_VALID, (oldColor, newColor) => ({oldColor, newColor}));

export const applyFinish = createAction(APPLY_FINISH, (apply) => ({ apply }));

/* 18759: Invalid options rollback
export const toggleShowInvalidOptionsRemovedWarning = createAction(TOGGLE_SHOW_INVALID_OPTIONS_REMOVED_WARNING);
*/
